module.exports = __webpack_public_path__ + "static/img/head1.2c7f47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head1.png
// module id = kNNG
// module chunks = 1